export default __webpack_public_path__ + "static/media/logoPortal.dae798bb.svg";